'use strict';

const { CLASSES } = require('./../utils/globals');
const SELECTORS = {
    inputFieldWrapper: '.js-field-wrapper',
    inputFieldInvalid: '.f-field.is-invalid',
    invalidFieldMessage: '.js-invalid-message',
};

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearFormErrors(form) {
    $(form).find(SELECTORS.inputFieldInvalid).removeClass(CLASSES.isInvalid);
    // checkbox fields get is-invalid on their wrapper (not on a .f-field);
    // reset the wrapper state and its message so they revalidate cleanly
    $(form).find(SELECTORS.inputFieldWrapper + '.' + CLASSES.isInvalid)
        .removeClass(CLASSES.isInvalid)
        .find(SELECTORS.invalidFieldMessage)
        .empty();
}

module.exports = function (formElement, payload) {
    // clear form validation first
    clearFormErrors(formElement);
    $('.alert', formElement).remove();

    if (typeof payload === 'object' && payload.fields) {
        Object.keys(payload.fields).forEach(function (key) {
            if (payload.fields[key]) {
                var feedbackElement = $(formElement).find('[name="' + key + '"]')
                    .closest(SELECTORS.inputFieldWrapper)
                    .find(SELECTORS.invalidFieldMessage);

                if (feedbackElement.length > 0) {
                    if (Array.isArray(payload[key])) {
                        feedbackElement.html(payload.fields[key].join('<br/>'));
                    } else {
                        feedbackElement.html(payload.fields[key]);
                    }

                    $(formElement).find('[name="' + key + '"]').parent().addClass(CLASSES.isInvalid);
                }
            }
        });
    }
    if (payload && payload.error) {
        var form = $(formElement).prop('tagName') === 'FORM'
            ? $(formElement)
            : $(formElement).parents('form');

        form.prepend('<div class="alert alert-danger" role="alert">'
            + payload.error.join('<br/>') + '</div>');
    }
};
